export default "__VITE_ASSET__CRC2PpqD__"